import { decorate, extendObservable, computed } from "mobx";
import Core from "Core";
import moment from "moment";

export class License extends Core.Stores.Model {
  constructor(store, id) {
    super(store, id);

    extendObservable(this, {
      CustomerId: null,
      ApplicationId: null,
      TypeId: null,
      Number: null,
      EndDate: null,
      InternalRemark: null
    });
  }

  get asJSON() {
    return {
      Id: this.Id,
      CustomerId: this.CustomerId,
      ApplicationId: this.ApplicationId,
      TypeId: this.TypeId,
      Number: this.Number,
      EndDate: this.EndDate instanceof moment ? this.EndDate.format() : null,
      InternalRemark: this.InternalRemark,
      LastUpdated: this.LastUpdated instanceof moment ? this.LastUpdated.format() : null
    };
  }

  getType() {
    let licenseType = null;

    if (this.TypeId === this.store.store.Enums.LicenseTypes.STANDARD.Key) licenseType = this.store.store.Enums.LicenseTypes.STANDARD.Name;
    else if (this.TypeId === this.store.store.Enums.LicenseTypes.RENTAL.Key) licenseType = this.store.store.Enums.LicenseTypes.RENTAL.Name;

    return licenseType;
  }

  parseAsDate(key) {
    return key.startsWith("Date") || key.endsWith("Date") || key === "LastUpdated";
  }
}

decorate(License, {
  asJSON: computed
});



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Models/License.js